import styled from "styled-components";
import bg from "../assets/images/kids-bg-2.jpg";
  const rootColor="#05C3DD";

   export const customStyles = {
        control: (provided) => ({
          ...provided,
          backgroundColor:rootColor,
          fontSize: "18px",
          fontWeight: 700,
          color: rootColor,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
          borderRadius: "10px",
          border: "none",
          outline: "none",
          margin: "0 auto",
          minHeight: "40px",
        }),
        singleValue: (provided) => ({
          ...provided,
          color: "#fff",
        }),
        placeholder: (provided) => ({
          ...provided,
          color: "#fff",
        }),
        option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isSelected ? rootColor : "#fff",
          color: state.isSelected ? "#fff" : "#000",
          cursor: "pointer",
        }),
        menu: (provided) => ({
          ...provided,
          borderRadius: "10px",
          marginTop: "5px",
        }),
      }
  export const PrimaryInput = styled.input`
  width: 100%;
  outline: none;
  border: none;
  height: 40px;
  border-radius: 6px;
  font-weight: 800;
  padding-left: 10px;
  @media screen and (max-width: 768px) {
    width: 90%;
  }
`;
  export const PrimaryButton = styled.button`
  background-color: #05C3DD;
  color: white;
  padding: 7px;
  width: 50%;
  margin: 15px 0;
  border: none;
  outline: none;
  font-size: 15px;
  border-radius: 6px;
  cursor: pointer;
  font-family: "Concert One", Times, serif;
  letter-spacing: 4px;
  font-weight: 700;
  :hover {
    background-color: black;
    color: #fff;
  }
  @media screen and (max-width: 768px) {
    width: 50%;
  }
`;

  export const ConfirmButton = styled.button`
  background-color:rgb(5, 221, 37);
  color: white;
  padding: 7px;
  width: 50%;
  margin: 15px 0;
  border: none;
  outline: none;
  font-size: 15px;
  border-radius: 6px;
  cursor: pointer;
  font-family: "Concert One", Times, serif;
  letter-spacing: 4px;
  font-weight: 700;
  :hover {
    background-color: black;
    color: #fff;
  }
  @media screen and (max-width: 768px) {
    width: 50%;
  }
`;

  export const CancelButton = styled.button`
  background-color:rgb(243, 16, 16);
  color: white;
  padding: 7px;
  width: 50%;
  margin: 15px 0;
  border: none;
  outline: none;
  font-size: 15px;
  border-radius: 6px;
  cursor: pointer;
  font-family: "Concert One", Times, serif;
  letter-spacing: 4px;
  font-weight: 700;
  :hover {
    background-color: black;
    color: #fff;
  }
  @media screen and (max-width: 768px) {
    width: 50%;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  background-color: #ffff;
  border-radius: 4px;
  font-size: 15px;
  margin-bottom: 10px;
  font-family: 700;
  color: gray;
  border: 2px solid grey;

  :active {
    border-color: green;
  }
 
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const HomeContainer = styled.div`
  background-image: url(${bg});
  linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.4)); */
  /* background-color: #fff; */
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  background-blend-mode: overlay;
  box-sizing: border-box;
  padding: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 768px) {
    padding: 25px 0 0;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin-top: 10px;
  width: 70%;
  @media screen and (max-width: 768px) {
    width: 100%;
    flex-direction: column-reverse;
  }
`;
export const InfoBox = styled.div`
  min-width: 60%;
  max-width: 100%;
  width: 500px;
  margin-top: -60px;
  h1 {
    color: black;
    /* font-size: 25px; */
    font-weight: 900;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI",
      Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue",
      sans-serif;
    text-align: center;
    font-size: 14px;
    padding: 9px;
  }
`;


export const SubInfo = styled.div`
  padding: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;  
  margin-top: 16px;
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(2.1px);
  border: 1px solid rgba(255, 255, 255, 0.09);
  width: 100%;
  h2 {
    color: #05C3DD;
    font-style: normal;
    font-weight: 700;
    font-size: 1.5rem;
    font-family: "Concert One", "Pacifico";
  }
  h3 {
    color: #f46b45;
    font-style: normal;
    font-weight: 700;
    font-size: 2rem;
    font-family: 'Skranji', "Concert One";
  }
  p {
    color:rgb(62, 64, 64);
    font-family: "Concert One", cursive;
    font-size:18px;
  }
    .img{
    width:160px;
    height:80px;
    }
  .select {
    width: 300px;
    font-family: Teko, robot;
    font-family: 700;
    color: grey;
    text-align: center;
  }
  .pack-select {
    display: grid;
    grid-template-rows: row row;
    grid-gap: 10px;
    margin: 10px;
  }
  .checkbox {
    color: #05C3DD;
    font-family: "Concert One", cursive;
    margin: 5px;
  }
  @media screen and (max-width: 768px) {
    h2 {
      text-align: center;
      font-size: 19px;
    }
    .select {
      width: 100%;
    }
  }
`;

